import React from 'react';
import { Mail, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative bg-black border-t border-red-900/30 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/logo2.png"
                alt="El Último Redentor"
                className="h-12 w-12 object-contain"
              />
              <span className="text-xl font-bold text-white tracking-wider section-subtitle">
                EL ÚLTIMO REDENTOR
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Una trilogía de fantasía oscura que trasciende las páginas.
              El universo extendido te espera.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold text-orange-500 mb-4">Enlaces</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://portal.grmeneghetti.com.ar/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-2"
                >
                  <ExternalLink size={16} />
                  Portal Web
                </a>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-orange-500 transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('app')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-orange-500 transition-colors"
                >
                  La App
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('universo')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-orange-500 transition-colors"
                >
                  El Universo
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-orange-500 mb-4">Contacto</h4>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              ¿Preguntas sobre el universo o la trilogía? Escríbenos.
            </p>
            <a
              href="mailto:contacto@grmeneghetti.com.ar"
              className="text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-2"
            >
              <Mail size={18} />
              Enviar mensaje
            </a>
          </div>
        </div>

        <div className="border-t border-red-900/30 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} El Último Redentor. Todos los derechos reservados.
            </p>
            <p className="text-gray-500 text-sm italic">
              "La Redención duele más que la condena"
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-96 h-32 bg-gradient-radial from-red-900/20 to-transparent blur-3xl pointer-events-none"></div>
    </footer>
  );
};

export default Footer;
